<template>
    <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="space-between" align="middle" class="p-3" :gutter="10">
          <el-col :span="16">
            <el-input placeholder="输入船东信息进行搜索..." v-model.trim="query.search"
                      @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>
            </el-input>
          </el-col>

          <el-col :span="8">
            <!-- <el-select placeholder="请选择批量导出文书" v-model="command_list" multiple clearable>
              <el-option v-for="option in command_options" :key="option.label"
                        :label="option.label" :value="option.value"></el-option>
            </el-select> -->
            &nbsp;&nbsp;
            <el-button type="primary" size="small" icon="el-icon-tickets" @click="openBatchExport">生成船舶入会申请书</el-button>
          </el-col>
        </el-row>
        <div>
          <el-table :key="0" :data="list" stripe v-loading="listLoading" :element-loading-text="loadingText" fit
                    highlight-current-row class="w-100" @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <!-- 客户名称 -->
            <el-table-column align="left" label="会员名称">
              <template slot-scope="scope">
                <span>{{scope.row.member_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="船名">
              <template slot-scope="scope">
                <span>{{scope.row.ship_name}}</span>
              </template>
            </el-table-column>
       
            <!-- 更新人 -->
            <el-table-column align="left" label="创建人">
              <template slot-scope="scope">
                <span>{{scope.row.updater_name ? scope.row.updater_name :scope.row.creator_name}}</span>
              </template>
            </el-table-column>
            <!-- 申请时间 -->
            <el-table-column align="left" label="申请时间">
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | parseTime }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="状态">
              <template slot-scope="scope">
                <span>{{ scope.row.status_name }}</span>
              </template>
            </el-table-column>
    
            <el-table-column align="left" label="操作">
              <template slot-scope="scope">
                <el-tooltip effect="light" content="提交审核" placement="top-start" v-show="[0].indexOf(scope.row.status) !== -1">
                  <el-button type="text" class="pr-1" @click="handleSubmit(scope.row)">
                    <i class="el-icon-s-promotion"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="审核" placement="top-start" v-show="[2].indexOf(scope.row.status) !== -1 && $perm(['member.auditing_ship_apply'])">
                    <el-button type="text" class="pr-1" @click="handleSuccess(scope.row) && $perm(['member.auditing_ship_apply'])">
                        <i class="el-icon-document-checked"></i>
                    </el-button>
                </el-tooltip>
                
                <el-tooltip effect="light" placement="top-start" content="查看">
                    <el-button type="text" @click="handleUpdate(scope.row)" ><i class="el-icon-view"></i></el-button>
                </el-tooltip>
<!--                 
                <el-tooltip effect="light" content="下载入会申请书" placement="top-start">
                  <el-button size="mini" type="text" @click="handlePrint(scope.row)"><i class="el-icon-download"></i></el-button>
                </el-tooltip> -->
               
                <el-tooltip effect="light" content="上传" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleUpload(scope.row)">
                    <i class="el-icon-upload"></i>
                  </el-button>
                </el-tooltip>
                <!-- <el-tooltip effect="light" content="审核不通过" placement="top-start">
                    <el-button type="text" class="pr-1" @click="handleReject(scope.row)">
                        <i class="el-icon-s-release"></i>
                    </el-button>
                </el-tooltip> -->
              </template>
            </el-table-column>
          </el-table>
          <pagination-new :size.sync="query.limit" :offset.sync="query.offset" :total="total"
                      @updateList="getList"></pagination-new>
          <upload-dialog ref="upload"
              :object-name="object_name"
              :file-type-list="file_type_list"
              object-type="member.membershipapply"
              :object-id="apply_id"
              :ship-list="shipList" 
              :customer-list="customerList"
              :is-upload="true"
              @uploaded="handleAppended">
          </upload-dialog>
        </div>
      </el-card>
      <make-document-dialog ref="makeDocument"
                            :command_list="command_list"
                            :data="multipleSelection">
      </make-document-dialog>
    </div>
  </template>
  
  <script>
    import {parseTime} from '@/utils'
    import PaginationNew from '@/components/PaginationNew'
    import {shipApplyList,successShipApply,rejectShipApply,shipSubmitApply} from '@/api/member'
    import UploadDialog from "@/components/UploadDialog"
    import { fetchFileTypeList } from "@/api/common"
    import {exportOther} from '@/api/group-insurance'
    import MakeDocumentDialog from '@/views/ib/group-insurance/make-document-dialog'
  
    export default {
      name: "applyList",
      components: {
        PaginationNew,
        UploadDialog,
        MakeDocumentDialog
      },
      filters: {
        parseTime
      },
      data() {
        return {
          list:[],
          query: {
            search: '',
            offset: 0,
            limit: 20
          },
          apply_id:"",
          object_name:"",
          searching: false,
          dialogVisible:false,
          customerList:[],
          shipList:[],
          groupList:[],
          file_type_list:[],
          listLoading: false,
          loadingText: '正在加载船东数据，请稍等...',
          list: [],
          total: 0,
          command_options: [{
            value: 'one',
            label: '企业会员入会申请书'
          }, {
            value: 'two',
            label: '个人会员入会申请书'
          }, {
            value: 'three',
            label: '船舶入会申请书'
          }],
          command_list: ['three'],
          multipleSelection: []
        }
      },
      methods: {
        handleSubmit(row) {
            this.$confirm('提交审核后，将不能再修改报名内容, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              shipSubmitApply({id: row.id})
              .then(res => {
                this.$message.success(res)
                this.getList()
              })
              .catch(err => {
                this.$error_message(err)
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
          },
        handleAppended(fileList) {
          this.$message({type: 'success', message: '文件上传成功!'})
        },
        handleUpload(row) {
          let customer_obj = {"id":row.customer,"name":row.customer_name}
          this.customerList.push(customer_obj)
          this.shipList = row.ship_list
          console.log(this.shipList,this.customerList)
          this.apply_id = row.id
          this.object_name = row.ship_name
          this.$refs.upload.handleOpen()
        },
        handlePrint(row){
          this.downloading = true
          this.downloadingText = '正在导出文书，请稍等...'
          exportOther({'data':row,'file_name':'船舶入会申请书'})
          .then(res => {
              let link = document.createElement('a')
              link.style.display = 'none'

              let blob = new Blob([res])
              link.href = URL.createObjectURL(blob)

              let ext_name = '.pdf'
              link.download = "小企业会员入会申请书" + ext_name
              document.body.appendChild(link)

              link.click()
              URL.revokeObjectURL(blob)
              document.body.removeChild(link)
              this.dialogVisible = false
              this.downloading = false
          })
          .catch(error => {
              this.downloading = false
          })
        },
        handleReject(row) {
          var msg = '是否拒绝该申请？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            rejectShipApply({'id':row.id})
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '拒绝成功!'
                })
                this.getList()
              })
              .catch(error => {
                this.$message.error(error)
              })
          })
        },
        handleUpdate(row){
          this.$router.push({ name: 'shipApplyDetail', query: {'type': 'ShowShipApply', 'id': row.id}})
        },
        handleSuccess(row) {
          this.$router.push({ name: 'shipApplyDetail', query: {'type': 'ApplySuccess', 'id': row.id}})
        //   var msg = '是否通过该申请？'
        //   this.$confirm(msg, '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'info'
        //   }).then(() => {
        //     successShipApply({'id':row.id,'member_id':row.member})
        //       .then(() => {
        //         this.$message({
        //           type: 'success',
        //           message: '通过成功!'
        //         })
        //         this.getList()
        //       })
        //       .catch(error => {
        //         this.$message.error(error)
        //       })
        //   })
        },
        setQueryStorage() {
            window.localStorage.setItem('query', JSON.stringify(this.query))
          },
        handleSearch() {
          this.getList()
        },
        getList() {
          // 从数据库中加载用户数据
          this.listLoading = true
          shipApplyList(this.query)
            .then(res => {
              this.list = res.results
              this.total = res.count
              this.listLoading = false
              window.localStorage.removeItem('query')
              this.$emit("toIndex", res.count)
            })
            .catch((error) => {
              this.listLoading = false
              this.$error_message(error)
            })
        },
        loadData() {
          this.loading = true
          let p = []
          p.push(fetchFileTypeList({file_type: "bc|sc|cc"}))

          Promise.all(p)
          .then(res => {
            this.file_type_list = res[0]
          })
          .catch(err => {
            this.loading = false
            this.$error_message(err)
          })
        },
        reset_commands() {
          return [{
                    value: 'one',
                    label: '企业会员入会申请书'
                  }, {
                    value: 'two',
                    label: '个人会员入会申请书'
                  }, {
                    value: 'three',
                    label: '船舶入会申请书'
                  }]
        },
        handleSelectionChange(val) {
          this.command_options = this.reset_commands()
          if (val.length > 0) {
            if (val[0]["customer_type"] === "0") {
              this.command_options.splice(1, 1)
            }
            else if (val[0]["customer_type"] === "1") {
              this.command_options.splice(0, 1)
            }

            this.multipleSelection = []
            const ships = val[0]["ship"]
            for (var key in ships) {
              const data = new Object()
              data["ship"] = key
              data["ship_name"] = ships[key]
              data["customer_name"] = val[0]["member_name"]
              data["customer"] = val[0]["customer"]
              data["customer_type"] = val[0]["customer_type"]
              this.multipleSelection.push(data)
            }
          }
        },
        openBatchExport(){
          if (this.multipleSelection.length === 0) {
                this.$error_message("请选择需制作文书的申请")
                return
              }

          const members = new Set()
          this.multipleSelection.forEach(item => {
            members.add(item.customer)
          })
          if (members.size !== 1) {
            this.$error_message("所选的报名不是同一个会员，请检查")
            return
          }
          
          this.$refs.makeDocument.handleMake('ship_apply')
        },
      },
      created() {
        this.query = JSON.parse(window.localStorage.getItem('query')) || {
            search: '',
            offset: 0,
            limit: 20
            
          }
        this.loadData()
        this.getList()
      }
    }
  </script>
  